import React, {Component} from 'react';
import Global from '../../Global';

class Search extends Component {

    constructor(props) {
        super(props);
        this.state = {
            searchData: {},
            searchField: "",
            searchLoading: false,
            searchNotFound: false,
            searchResultsData: {"searchResults": []},
            searchCategoryActive: "catAll"
        }

        this.handleSearchFieldChange = this.handleSearchFieldChange.bind(this);
        this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
        this.handleSearchCategoryClick = this.handleSearchCategoryClick.bind(this);
        this.handleSearchClose = this.handleSearchClose.bind(this);
    }

    componentWillMount() {

// FETCH JSON

        var url = Global.getAPI('search');
        var self = this;
        fetch(url)
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Error API: search");
                }
                return response.json();
            })
            .then(function (data) {

                // let's split the trending array into groups of 2 for easier HTML rendering
                var trendingArray = data.trending.items;
                var arrays = [], size = 2;

                while (trendingArray.length > 0) {
                    arrays.push(trendingArray.splice(0, size));
                }

                self.setState({
                    searchData: data,
                    searchDataTrending: arrays
                }, function () {
                    window.THREE_MAIN.search.init();
                });

            });

    }

    /*
    Trending
    */

    getTrendingNowBlockHTML() {

        var trendingArray = this.state.searchDataTrending;

        if (trendingArray.length) {

            let html = trendingArray.map((cells, index) =>
                <div key={index} className="row">
                    {this.getTrendingNowBlockInnerHTML(cells)}
                </div>
            );

            return (
                <div className="col-xs-12 col-sm-7 trending-now-block">
                    <h2>{this.state.searchData.trending.title}</h2>
                    {html}
                </div>
            );

        } else {
            return false;
        }

    }

    getTrendingNowBlockInnerHTML(columns) {

        let html = columns.map((column, index) =>
            <div key={index} className="col-xs-6 trending-item-block">
                <a href={column.url}>
                    <img src={column.src} className="img-responsive" alt={column.alt}/>
                </a>
            </div>
        );

        return html

    }

    /*
    Quick Links
    */

    getQuickLinksBlockHTML() {

        return (
            <div className="col-xs-12 col-sm-5 quick-links-block hidden-xs">
                <div className="row">
                    {this.getQuickLinksBlockLeftHTML()}
                    {this.getQuickLinksBlockRightHTML()}
                </div>
            </div>
        );

    }

    /*
    Column 1
    */

    getQuickLinksBlockLeftHTML() {

        var array = this.state.searchData.column1.items;

        if (array.length) {
            let html = array.map((item, index) =>
                <li key={index}>
                    <a href={item.url}>{item.label}</a>
                </li>
            );

            return (
                <div className="col-xs-12 col-sm-6">
                    <h2>{this.state.searchData.column1.title}</h2>
                    <div className="links-body">
                        <ul className="links-list">
                            {html}
                        </ul>
                    </div>
                </div>
            );
        } else {
            return false;
        }

    }

    /*
    Column 2, 3
    */

    getQuickLinksBlockRightHTML() {

        if (this.state.searchData.column2.items.length || this.state.searchData.column3.items.length) {
            return (
                <div className="col-xs-6 col-sm-6 hidden-xs">
                    {this.getQuickLinksBlockRightInnerLeftHTML()}
                    {this.getQuickLinksBlockRightInnerRightHTML()}
                </div>
            );
        } else {
            return false;
        }
    }

    getQuickLinksBlockRightInnerLeftHTML() {

        if (this.state.searchData.column2.items.length) {

            let html = this.state.searchData.column2.items.map((item, index) =>
                <li key={index}>
                    <a href={item.url}>{item.label}</a>
                </li>
            );

            return (
                <div className="row">
                    <div className="col-xs-12 cs-links-block">
                        <span class="title">{this.state.searchData.column2.title}</span>
                        <div className="links-body">
                            <ul className="links-list">
                                {html}
                            </ul>
                        </div>
                    </div>
                </div>
            );
        } else {
            return false;
        }

    }

    getQuickLinksBlockRightInnerRightHTML() {

        if (this.state.searchData.column3.items.length) {

            let html = this.state.searchData.column3.items.map((item, index) =>
                <li key={index}>
                    <a href={item.url}>{item.label}</a>
                </li>
            );

            return (
                <div className="row">
                    <div className="col-xs-12 cs-links-block">
                        <span class="title">{this.state.searchData.column3.title}</span>
                        <div className="links-body">
                            <ul className="links-list">
                                {html}
                            </ul>
                        </div>
                    </div>
                </div>
            );

        } else {
            return false;
        }

    }

    handleSearchFieldChange(e) {
        var searchField = e.currentTarget.value;
        this.setState({
            searchField: searchField
        });
    }

    handleSearchFieldKeyPress(e) {
        var code = e.keyCode || e.which;
        if (code == 13) {
            document.getElementById('btn-search').click();
            e.preventDefault();
        }
    }

    /*
    Search AJAX
    */

    handleSearchSubmit(e) {

        var searchTerm = document.getElementById('search-field').value;

        this.setState({
            searchLoading: true
        }, function () {

            // do the ajax

            var url = window.THREE_REACT_APP_GLOBAL.api_endpoint + window.THREE_REACT_APP_GLOBAL.language + "/search-results.json?search=" + encodeURIComponent(searchTerm);
            var self = this;
            fetch(url)
                .then(function (response) {
                    if (response.status >= 400) {
                        throw new Error("Error API: search results");
                    }
                    return response.json();
                })
                .then(function (data) {

                    if (data.searchResults.length > 0) {

                        self.setState({
                            //searchResultsData: data,
                            //searchNotFound: false,
                            searchLoading: false
                        }, function(){self.props.setSearchResultStates(data, false)});

                    } else {

                        self.setState({
                            //searchResultsData: data,
                            //searchNotFound: true,
                            searchLoading: false
                        }, function(){self.props.setSearchResultStates(data, true)});

                    }

                });

        });

    }

    /*
    Search Loading
    */

    searchLoadingHTML() {
        let lang = window.THREE_REACT_APP_GLOBAL.language || "en";
        let searchingImgPath = '';

        if(lang !== "en"){
            searchingImgPath = '/assets/images/search/searching-tc.png';
        } else {
            searchingImgPath = '/assets/images/search/is-searching.png';
        }

        return (
            <div className="section-is-searching">
                <div className="col-xs-12">
                    <div className="loading-placeholder">
                        
                        <img className="img-responsive" src={(searchingImgPath)} alt="Searching"/>


                    </div>
                </div>
            </div>
        );

    }

    /*
    Search No Results
    */

    searchNotFoundHTML() {

        return (
            <div className="section-is-no-results">
                <div className="col-xs-12">
                    {this.props.searchResultStates.searchResultsData.noResultsMessage}
                </div>
            </div>
        );

    }

    /*
    Search Results
    */

    searchResultsHTML() {
        return (
            <div className="section-search-result">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-12 search-result-category-heading">
                            {this.getSearchResultsCategories()}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-7 col-sm-push-2 search-result-list">
                            <div className="search-result-panel">
                                {this.getSearchResultsHTML()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    getSearchResultsCategories() {

        if (typeof this.props.searchResultStates.searchResultsData.categories !== "undefined") {
            let html = this.props.searchResultStates.searchResultsData.categories.map((category, index) =>
                <li key={index} className={this.state.searchCategoryActive == category.id ? "is-active" : ""}><a
                    href="javascript:void(0)" data-category={category.id}
                    onClick={this.handleSearchCategoryClick}>{category.label}</a></li>
            );

            return (
                <ul className="category-heading-list">
                    {html}
                </ul>
            );
        } else {
            return "";
        }

    }

    handleSearchCategoryClick(e) {

        var searchCategoryActive = e.currentTarget.getAttribute('data-category');

        this.setState({
            searchCategoryActive: searchCategoryActive
        });

    }

    getSearchResultsHTML() {

        // filter by category

        let html = this.props.searchResultStates.searchResultsData.searchResults.map((result, index) =>
            (this.getSearchResultsByCategory(result.category) ?
                    <div key={index} className="row search-result">
                        <div className="col-xs-2 thumbnail">
                            {result.img !== "" &&
                            <img className="img-responsive" src={result.img} alt={result.alt}/>
                            }
                        </div>
                        <div className="col-xs-10 search-result-body">
                            <a href={result.url}><h2>{result.title}</h2></a>
                            <p>
                                {result.summary}
                            </p>
                        </div>
                    </div>

                    :
                    ""
            )
        );

        return html;

    }

    /*
    Filter Search Results By Category
    */

    getSearchResultsByCategory(category) {
        if (this.state.searchCategoryActive == "catAll") {
            return true;
        } else {

            if (category.indexOf(this.state.searchCategoryActive) != -1) {
                return true;
            } else {
                return false;
            }

        }
    }

    /*
    Search Close
    */

    handleSearchClose() {

        this.setState({
            searchField: "",
            searchLoading: false,
            //searchNotFound: false,
            //searchResultsData: {"searchResults": []},
            searchCategoryActive: "catAll"
        }, this.props.setSearchResultStates({searchResults: []}, false));

    }

    render() {

        if (Object.keys(this.state.searchData).length === 0) {
            return false;
        }
        else {
          let searchResultStates = this.props.searchResultStates;

            return (

                <div id="search" className="search">
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12 close-search-block">
                                <button type="button" id="btn-close-search" className="btn-close-search btn-image"
                                        onClick={this.handleSearchClose}></button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 search-field-block">
                                <form>
                                    <div className="row">
                                        <div className="col-xs-9 col-sm-12 form-group">
                                            <input type="text" id="search-field" className="search-field" name="search"
                                                   value={this.state.searchField}
                                                   onChange={this.handleSearchFieldChange}
                                                   onKeyPress={this.handleSearchFieldKeyPress}/>
                                        </div>
                                        <div className="col-xs-3 col-sm-12 form-group">
                                            <button type="button" id="btn-search" className="btn-search btn-image"
                                                    onClick={this.handleSearchSubmit}><img
                                                src="/assets/images/search/btn-search.png" alt="Search"/></button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {!this.state.searchLoading && searchResultStates.searchResultsData.searchResults.length == 0 && !searchResultStates.searchNotFound &&
                        <div className="row">
                            <div className="content-container">
                                <div className="section-search-default">
                                    {this.getTrendingNowBlockHTML()}
                                    {this.getQuickLinksBlockHTML()}
                                </div>
                            </div>
                        </div>}{/* row END */}

                        {this.state.searchLoading &&
                        this.searchLoadingHTML()
                        }

                        {searchResultStates.searchResultsData.searchResults.length > 0 &&
                        this.searchResultsHTML()
                        }

                        {searchResultStates.searchNotFound &&
                        this.searchNotFoundHTML()
                        }

                    </div>
                </div>
            );
        }

    }
}

export default Search;
